<template>
	<FileManager
	    ref="fileManager"
		:service="fileService"
		:prefix="id"
		accept=".pdf"
		v-bind="{
			selected,
			submitted,   
		}"
		v-slot="{
			browse,
			canMerge,
			deleted,
			empty,
			loading,
			merge,
			merging,
			prefix,
			refresh,
			renamed,
			results,
			uploading,
			uploadPercent,
			zip,
			zipping,
		}"
		@loaded="filesLoaded"
		@merged="mergedDocuments"
		@zipped="zippedDocuments"
		@error="fileError($event)"
	>
		<b-row class="d-flex align-items-center">
			<b-col cols="4" lg="6" xl="4" class="mb-2 text-left">
				<b-button-group>
					<!-- <b-button
						variant="secondary"
						@click="toggleList"
						:disabled="loading || uploading"
						class="px-2 px-lg-4 mr-2 mt-1"
						style="padding-right:2px;"
						v-if="(showList || !showList) && previewing"
					>
					<span v-if="showList && previewing"><|</span>
					<span v-if="!showList && previewing">|></span>
					</b-button> -->

					<!-- <b-button
						variant="secondary"
						@click="toggleList"
						:disabled="loading || uploading"
						class="px-2 px-lg-4 mr-2"
						style="padding-right:2px;"
						v-if="(showList || !showList) && previewing"
					>
					<span v-if="showList && previewing"><|</span>
					<span v-if="!showList && previewing">|></span>
					</b-button> -->

					<b-button
						variant="light"
						@click="browse"
						:disabled="loading || uploading"
						title="Upload"
						class="px-2 px-lg-4 mt-1 btn btn-outline-primary"

					>
						<font-awesome-icon icon="cloud-upload-alt" fixed-width class="mr-2" />
						 <!-- <span>Upload</span>  -->
					</b-button>

					<b-button v-if="showRefresh" variant="light" @click="refresh" :disabled="loading" title="Refresh">
						<font-awesome-icon icon="refresh" fixed-width :spin="loading" />
						<span class="sr-only">Refresh</span>
					</b-button>
				</b-button-group>
			</b-col>
			<b-col cols="8" lg="6" xl="8" class="mb-2 text-right">
				<transition name="fade" mode="out-in">
					<div v-if="selected.length > 0">
						<b-button
							variant="info"
							@click="merge(selected)"
							:disabled="merging || !canMerge"
							title="Create a combined PDF file from multiple source files"
							v-if="selected.length > 1"
						>
							<font-awesome-icon icon="file-pdf" fixed-width />
							Merge PDFs
						</b-button>

						<b-button
							variant="info"
							@click="zip(selected)"
							:disabled="zipping"
							title="Create a .zip archive of selected files"
						>
							<font-awesome-icon icon="file-zipper" fixed-width />
							Zip Files
						</b-button>
					</div>
				</transition>
			</b-col>
		</b-row>
		<b-row v-if="previewing">
		<b-col cols="12" class="my-2">
			<div class="horizontal-scroll-container">
				<b-form-checkbox-group v-model="selected" name="selected">
			<b-list-group :flush="flush" class="horizontal-scroll-list">
				<transition-group name="fade" mode="out-in">
				<FileManagerItem
					v-for="(result, index) in results"
					:key="result.path"
					:prefix="prefix"
					:service="fileService"
					:value="result"
					ref="fileItems"
  					:ref-in-for="true"
					v-slot="{
					canDelete,
					canDownload,
					canPreview,
					canRename,
					deleting,
					destroy,
					download,
					extension,
					fileName,
					isDirectory,
					lastModified,
					lastModifiedTimeAgo,
					mimeType,
					name,
					previewUrl,
					rename,
					renaming,
					size
					}"
					@deleted="deleted"
					@error="fileError($event)"
					@renamed="renamed"
				>
					<b-list-group-item :disabled="deleting" :active="previewUrl === previewingUrl">
					<div class="d-flex">
						<div>
						<b-form-checkbox :value="fileName" />
						</div>
						<div>
						<a
							href="#"
							v-if="canPreview"
							@click.prevent="previewFile(fileName, previewUrl)"
							class="font-weight-bold"
							:title="`${name}\n${size}\n${lastModified.toLocaleDateString()}`"
							:class="{ 'text-white': previewUrl === previewingUrl, 'text-dark': previewUrl !== previewingUrl }"
						>
							{{ name.substring(0, 12) }}
						</a>
						<span v-else>{{ name.substring(0, 12) }}</span>
						</div>
					</div>
					</b-list-group-item>
				</FileManagerItem>
				</transition-group>
			</b-list-group>
			</b-form-checkbox-group>
			</div>
		</b-col>
		</b-row>


		<transition name="fade" mode="out-in">
			<b-row v-if="uploading">
				<b-col cols="12" class="my-2">
					<b-progress v-show="uploading" :max="100" height="2rem" animated striped>
						<b-progress-bar :value="uploadPercent" class="my-0">
							<h5 class="my-0">{{ uploadPercent.toFixed(0) }}%</h5>
						</b-progress-bar>
					</b-progress>
				</b-col>
			</b-row>
		</transition>
		<div>
    <loading-indicator v-if="loading && empty" class="my-5" />
    <div v-else>
		<div v-if="results.length > 0">
			<b-row>
				<b-col cols="6" class="selectAllFiles">
					<input type="checkbox" id="checkbox" v-model="selectAllFiles" @change="changeFileSelection(results)" style="transform: scale(1.2);"/>
					<label for="checkbox" class="selectAllFilesLabel">{{ checkboxLabel }}</label>

					<button class="deleteAllAppealFilesBtn" @click="deleteAllFiles(results)" style="cursor: pointer;" v-if="selectAllFiles || selected.length > 1">
						<i class="fas fa-trash text-danger"></i>
					</button>							
				</b-col> 
				<b-col cols="5" class="text-right">
					<div class="selectedFileCount">
						<span v-if="selected.length == results.length">
							<span style="color: grey;font-size: small;">All files selected</span>
						</span>
						<span v-else style="color: grey;font-size: small;">
							<span v-if="selected.length >=1">{{ selected.length }} Selected out of </span><span>{{ results.length }} Files</span>
						</span>
					</div>
				</b-col>
			</b-row>
		</div>
        <b-row no-gutters>
            <!-- PDF Frame -->
            <b-col
                v-if="previewing"
                :cols="showList ? 12 : 12"
                :lg="showList ? 12 : 12"
                :xl="showList ? 12 : 12"
                class="text-right"
            >
                <PdfFrame :url="previewingUrl"/>
            </b-col>

            <!-- File List -->
            <b-col
                v-if="!previewing"
                cols="12"
                :lg="previewing ? 6 : 12"
                :xl="previewing ? 4 : 12"
            >
                <b-form-checkbox-group v-model="selected" name="selected">
                    <b-list-group :flush="flush" :class="{ 'scrollable-list': results.length > 10 }">
                        <transition-group name="fade" mode="out-in">
                            <FileManagerItem
                                v-for="(result, index) in results"
                                :key="result.path"
                                :prefix="prefix"
                                :service="fileService"
                                :value="result"
								ref="fileItems"
  								:ref-in-for="true"
								:checked="result.checked"
 								@update:checked="(val) => result.checked = val"
                                v-slot="{
                                    canDelete,
                                    canDownload,
                                    canPreview,
                                    canRename,
                                    deleting,
                                    destroy,
                                    download,
                                    extension,
                                    fileName,
                                    isDirectory,
                                    lastModified,
                                    lastModifiedTimeAgo,
                                    mimeType,
                                    name,
                                    previewUrl,
                                    rename,
                                    renaming,
                                    size,
									checked,
									toggleChecked
                                }"
                                @deleted="deleted"
                                @error="fileError($event)"
                                @renamed="renamed"
                            >
                                <b-list-group-item :disabled="deleting" :active="previewUrl === previewingUrl">
                                    <b-row>
                                        <b-col cols="9" md="8" xl="9" class="text-left">
                                            <b-row>
                                                <b-col cols="12">
                                                    <div v-if="deleting">Deleting...</div>
                                                    <div v-else-if="!isDirectory">
                                                        <div class="d-flex">
                                                            <div>
                                                                <b-form-checkbox :value="fileName" @change="toggleChecked"/>
                                                            </div>
                                                            <div>
                                                                <a
                                                                    href="#"
                                                                    v-if="canPreview"
                                                                    @click.prevent="previewFile(fileName, previewUrl)"
                                                                    class="font-weight-bold"
                                                                    :class="previewUrl === previewingUrl ? 'text-white' : 'text-dark'"
                                                                >
                                                                    {{ name }}
                                                                </a>
                                                                <span v-else>{{ name }}</span>
                                                            </div>
                                                        </div>
                                                        <div v-if="!previewing" class="d-flex">
                                                            <div class="small text-muted">
                                                                <span v-if="extension">{{ extension }}</span>
                                                                <span v-if="extension && size">&middot;</span>
                                                                <span v-if="size">{{ size }}</span>
                                                            </div>
                                                            <div class="small text-muted ml-3">
                                                                <span>{{ lastModified.toLocaleDateString() }}</span>
                                                                &middot;
                                                                <span>{{ lastModifiedTimeAgo }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-else-if="isDirectory">
                                                        <div>
                                                            <font-awesome-icon icon="folder" fixed-width class="mr-4 text-muted" />
                                                        </div>
                                                        <div>
                                                            <a href="#">{{ name }}</a>
                                                        </div>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col cols="3" md="4" xl="3" class="text-right">
                                            <b-button-group>
                                                <b-dropdown right variant="light">
                                                    <template #button-content>
                                                        <font-awesome-icon icon="cog" fixed-width />
                                                    </template>
                                                    <b-dropdown-item
                                                        @click="download"
                                                        :disabled="deleting || !canDownload"
                                                    >
                                                        Download
                                                    </b-dropdown-item>
                                                    <b-dropdown-item
                                                        :href="previewUrl"
                                                        target="_blank"
                                                        :disabled="deleting || !canPreview"
                                                    >
                                                        Preview
                                                    </b-dropdown-item>
                                                    <b-dropdown-item
                                                        @click="rename"
                                                        :disabled="renaming || !canRename"
                                                    >
                                                        Rename
                                                    </b-dropdown-item>
                                                    <b-dropdown-divider />
                                                    <b-dropdown-item
                                                        variant="danger"
                                                        @click="destroy"
                                                        :disabled="deleting || !canDelete"
                                                    >
                                                        <font-awesome-icon icon="trash" />
                                                        <span>Delete</span>
                                                    </b-dropdown-item>
                                                </b-dropdown>
                                            </b-button-group>
                                        </b-col>
                                    </b-row>
                                </b-list-group-item>
                            </FileManagerItem>
                        </transition-group>
                    </b-list-group>
                </b-form-checkbox-group>
            </b-col>
        </b-row>
    </div>
			<empty-result v-if="!loading && empty" icon="cloud-upload-alt">
				No documents uploaded
				<template #content>
					<p class="mb-0">Drag and drop files to attach to this case.</p>
					<p class="mb-0">Case files are available to all levels.</p>
				</template>
			</empty-result>
		</div>
	</FileManager>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import FileManager from "@/clients/components/Layout/file-manager.vue";
import FileManagerItem from "@/clients/components/Layout/file-manager-item.vue";
import PdfFrame from "@/shared/components/PdfFrame.vue";

import * as CaseFileService from "@/clients/services/caseFiles";

export default {
	name: "CaseFiles",
	components: {
		FileManager,
		FileManagerItem,
		PdfFrame,
	},
	props: {
		id: {
			required: true,
			type: [Number, String],
			default: "",
		},
		flush: {
			type: Boolean,
			default: true,
		},
		showRefresh: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			fileService: CaseFileService,
			selected: [],
			previewing: false,
			previewingUrl: "",
			showList:true,
			myData: null,
			selectAllFiles: false,
			checkboxLabel: 'Select All Items',
		};
	},
	methods: {
		refresh() {
			this.$refs.fileManager.refresh();
		},
		updateComponent(data) {
			this.refresh();
			
			this.myData = data;
		},
		filesLoaded(list) {
			// Cancel previewing if going to display empty
			if (!list || !list.length > 0) {
				this.previewing = false;
			}
		},
		async previewFile(fileName, previewUrl) {
			this.showList = true; //to hide the file list.
			if (previewUrl == this.previewingUrl) {
				this.previewing = false;
				this.previewingUrl = "";
				this.$emit("previewing", false);
			} else {
				this.previewing = true;
				this.previewingUrl = previewUrl;
				this.$emit("previewing", true);
			}
		},
		mergedDocuments(data) {
			const fileCount = data.data.length || 0;
			this.selected = [];

			this.$store.dispatch("notify", {
				variant: "primary",
				title: "Documents Merged",
				message: `${fileCount} file(s) merged into ${data.name}`,
			});
		},
		zippedDocuments(data) {
			const fileCount = data.data.length || 0;
			this.selected = [];

			this.$store.dispatch("notify", {
				variant: "primary",
				title: "Documents Zipped",
				message: `${fileCount} file(s) zipped into ${data.name}`,
			});
		},
		fileError(event) {
			this.$store.dispatch("apiError", {
				error: e,
				title: "File Error",
				message: event.message || "Unable to complete file operation and no message was provided.",
			});
		},
		toggleList(){
			this.showList = !this.showList;
		},
		changeFileSelection(files){
			const filePaths = [];
			this.selected = [];
			files.forEach(file => {
				files.checked = true;
				if(this.selectAllFiles){
					filePaths.push(file.path);
				}
				this.selected.push(file.path.replace(/^[^/]+\//, ""));
			});
			if(this.selectAllFiles == false){
				this.selected = [];
			}
			this.checkboxLabel = !this.selectAllFiles ? 'Select All Files' : 'Deselect All Files';
			this.$emit('update:selected', this.selectAllFiles ? filePaths : []);	
		},
		deleteAllFiles(files) {
			if (!confirm("Are you sure you want to delete all selected files?")) return;
			if(this.selectAllFiles){
				files.forEach((file, index) => {
					// if (file.checked == false && this.$refs.fileItems?.[index]) {
					// // if (this.$refs.fileItems?.[index]) {
					// 	this.$refs.fileItems[index].destroy({ silent: true });
					// }
					if(this.selected.includes(file.path.replace(/^[^/]+\//, ""))){
						this.$refs.fileItems[index].destroy({ silent: true });
					}
				});
			}else{
				files.forEach((file, index) => {
					// if (file.checked && this.$refs.fileItems?.[index]) {
					// // if (this.$refs.fileItems?.[index]) {
					// 	this.$refs.fileItems[index].destroy({ silent: true });
					// }
					if(this.selected.includes(file.path.replace(/^[^/]+\//, ""))){
						this.$refs.fileItems[index].destroy({ silent: true });
					}
				});
			}
			
			this.checkboxLabel = 'Select All Files';
			this.selectAllFiles = false;
			this.selected = [];
			this.$emit('update:selected', []);
		},
		onCheckboxChange(event, result) {
			// Additional logic here
			result.checked = event;
			console.log('Checkbox toggled:', result.fileName, 'Checked:', result.checked);
		}
	},
	watch: {
		previewing(val) {
			if (!val) {
				this.previewingUrl = "";
			}
		},
		selected: {
			handler(val) {
				this.$emit("update:selected", val);
			},
		},
		myData(val) {
			if (val) {
			this.previewing = false;
			}
		},
	},
};
</script>
<style>
.scrollable-list {
  max-height: 821px; /* Adjust the height as needed */
  overflow-y: auto;
}
.horizontal-scroll-container {
  overflow-x: auto; /* Enable horizontal scrolling */
  white-space: nowrap; /* Prevent wrapping of content */
}

.horizontal-scroll-list {
  display: inline-block; /* Make the list items display inline */
  white-space: nowrap; /* Prevent list items from wrapping */
}

.horizontal-scroll-list .list-group-item {
  display: inline-block; /* Make each item display inline */
}
.selectAllFiles {
	font: bold;
	font-size: 12px;
	color: black;
	margin-left: 21px;
	margin-top: 14px;
}
.selectAllFilesLabel {
	vertical-align: middle;
	margin-left: 8px;
}
.deleteAllAppealFilesBtn{
	border: none;
    border-left: 2px solid #cbcbcb;
    background: none;
    margin-left: 8px;
    vertical-align: text-bottom;
}
.selectedFileCount {
	text-align: right;
	font-size:xx-small;
	padding-top: 20px;
}

</style>
